<h4>Fuel Gauge Widget Editor</h4>


<mat-tab-group style="overflow: hidden">
  <mat-tab label="Appearance">
    <div>
      <mat-form-field>
        <mat-label>Title Label</mat-label>
        <input matInput [(ngModel)]="widget.title" name="widget.title">
      </mat-form-field>
    </div>

    <widget-background-colour [widget]="widget"></widget-background-colour>

    <!--<widget-graph-colour-presets [widget]="widget"></widget-graph-colour-presets>-->

    <mat-form-field appearance="fill" style="width:100%;">
      <mat-label>Select a Gauge Type</mat-label>
      <mat-select [(ngModel)]="widget.gaugeType" name="gaugeType">
        <mat-option>None</mat-option>
        <mat-option value="full">Full</mat-option>
        <mat-option value="semi">Semi</mat-option>
        <mat-option value="arch">Arch</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill" style="width:100%;">
      <mat-label>Select a Gauge Ending Style</mat-label>
      <mat-select [(ngModel)]="widget.gaugeEndStyle" name="gaugeEndStyle">
        <mat-option>None</mat-option>
        <mat-option value="butt">Flat</mat-option>
        <mat-option value="round">Round</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Fuel Gauge Label</mat-label>
      <input matInput [(ngModel)]="widget.gaugeLabel" name="widget.gaugeLabel">
    </mat-form-field>

    <mat-form-field>
      <mat-label>Fuel Gauge Prefix</mat-label>
      <input matInput [(ngModel)]="widget.gaugeAppendText" name="widget.gaugeAppendText">
    </mat-form-field>

    <div>
      <h4>Gauge Thickness</h4>
      <div style="display: flex;">
        <input style="flex: 0 0 30px" matInput [(ngModel)]="widget.thickness" name="widget.thickness" placeholder="0">
        <mat-slider style="flex: 1 1 auto"
                    class="example-margin"
                    disabled="false"
                    max="100"
                    min="0"
                    step="1"
                    discrete="false"
                    showTickMarks="false"
                    [(ngModel)]="widget.thickness"
                    [value]="widget.thickness ?? 0"
                    name="widget.thickness"
                    (input)="onThicknessSliderChange($event)">
        </mat-slider>
      </div>
    </div>

    <div>
      <h4>Gauge Animation Duration</h4>
      <div style="display: flex;">
        <input style="flex: 0 0 5%" matInput [(ngModel)]="widget.animationDuration" name="widget.animationDuration" placeholder="0">
        <div style="flex: 0 0 30px; margin: auto;">(ms)</div>
        <mat-slider style="flex: 1 1 auto"
                    class="example-margin"
                    disabled="false"
                    max="10000"
                    min="1"
                    step="1"
                    discrete="false"
                    showTickMarks="false"
                    [(ngModel)]="widget.animationDuration"
                    [value]="widget.animationDuration ?? 0"
                    name="widget.animationDuration"
                    (input)="onAnimationDurationSliderChange($event)">
        </mat-slider>
      </div>
    </div>

    <div>
      <div style="display: flex;">
        <h4 style="flex: 1 1 auto;">Gauge Thresholds</h4>

        <button mat-raised-button color="primary" aria-label="Add a new threshold setting" (click)="addNewThreshold()" style="text-align: right; margin: auto 0;">
          <mat-icon>add</mat-icon> New Threshold
        </button>
      </div>



      <div *ngFor="let setting of widget.thresholdSettings; index as i" style="display: flex; background-color: #b6b6b6; box-shadow: rgba(0, 0, 0, 0.07) 0px 1px 2px, rgba(0, 0, 0, 0.07) 0px 2px 4px, rgba(0, 0, 0, 0.07) 0px 4px 8px, rgba(0, 0, 0, 0.07) 0px 8px 16px, rgba(0, 0, 0, 0.07) 0px 16px 32px, rgba(0, 0, 0, 0.07) 0px 32px 64px;">
        <div style="flex: 1 1 auto; margin: 10px">
          <div style="display: flex; flex-direction: column">
            <mat-label style="text-align: center">Threshold Minimum Value</mat-label>
            <input matinput type="number" [(ngModel)]="setting.minimumValue" [name]="'setting.minimumValue-' + i" min="0" [max]="widget.thresholdSettings.indexOf(setting) == 0 ? 0 : 100" style="text-align: center">
          </div>
        </div>

        <div style="flex: 1 1 auto; margin: auto 10px; text-align: center;">
          <div style="display: flex; flex-direction: column">
            <mat-label style="text-align: center">Threshold Colour</mat-label>
            <input [(colorPicker)]="setting.colour" [style.background]="setting.colour" [cpOutputFormat]="'rgba'" required />
            <!--{{setting.colour}}-->
          </div>
        </div>

        <div style="flex: 1 1 auto; margin: auto; text-align: center;">
          <mat-checkbox [(ngModel)]="setting.showInBackground" [name]="'setting.showInBackground-' + i" labelPosition="before">Show in Gauge Background</mat-checkbox>
        </div>

        <div style="flex: 1 1 auto; margin: auto; text-align: center">
          <button mat-icon-button color="warn" aria-label="Remove Threshold" (click)="removeThresholdSetting(setting)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>

      </div>

    </div>

  </mat-tab>

  <mat-tab label="Data">
    
    <widget-datasource [dataSource]="widget.dataSource"></widget-datasource>
    <!--<div>
    <mat-form-field>
      <mat-label>x-Axis Label</mat-label>
      <input matInput [(ngModel)]="widget.xAxisLabel" name="widget.xAxisLabel">
    </mat-form-field>
  </div>

  <div>
    <mat-form-field>
      <mat-label>y-Axis Label</mat-label>
      <input matInput [(ngModel)]="widget.yAxisLabel" name="widget.yAxisLabel">
    </mat-form-field>
  </div>-->

  </mat-tab>

  <mat-tab label="Interactivity">
    <h4>Graph Click Event</h4>
    
    <div>
      <mat-radio-group *ngFor="let type of enumKeys" class="example-radio-group" [(ngModel)]="widget.onClick.type" name="widget.onClick.type">
        <mat-radio-button class="example-margin" [value]="graphClickEventTypes[type]">{{type}}</mat-radio-button>
      </mat-radio-group>
    </div>

    <div *ngIf="widget.onClick.type == graphClickEventTypes.alert">
      <mat-form-field>
        <mat-label>Alert Text</mat-label>
        <input matInput [(ngModel)]="widget.onClick.text" name="widget.onClick.text">
      </mat-form-field>
    </div>

    <div *ngIf="widget.onClick.type == graphClickEventTypes.url">

      <mat-form-field>
        <mat-label>URL</mat-label>
        <input matInput [(ngModel)]="widget.onClick.url" name="widget.onClick.url">
      </mat-form-field>
    </div>


    <!--{{graphClickEventTypes[widget.onClick.type]}}-->
  </mat-tab>

  <mat-tab label="Alerts"> Alerts </mat-tab>
</mat-tab-group>
